<template>
    <v-card class="pb-4">
      <v-toolbar dense flat>
        <v-toolbar-title>Trade Executions</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs12 md12>
            <v-autocomplete
              v-model="form.account"
              label="Account"
              :items="accounts"
              item-text="account_id"
              return-object
              :search-input.sync="accountSearch"
              :disabled="!accounts.length || loading"
              prepend-icon="mdi-account"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.date"
              :value="form.date"
              :disabled="!currentExchangeConfig"
              label="Date"
              type="datetime-local"
              step="1"
              required
              prepend-icon="mdi-timer"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-if="currentExchangeConfig && currentExchangeConfig.endDate"
              v-model="form.endDate"
              :value="form.endDate"
              label="End Date"
              type="datetime-local"
              step="1"
              prepend-icon="mdi-timer-sand"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn :disabled="!valid || loading" :loading="loading" color="primary" @click="submit">Submit</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MessageDialog from '../../libs/message-dialog/'
import MongoConnector from '../../services/mongo-connector.service'
import { getDefaultConnectorSchema } from '../../configs/schemas'
import { merge } from 'lodash'
import { parseFormInputValue } from '../../libs/utils'
import moment from 'moment'
export default {
  data() {
    const exchangeConfigs = {
      'kraken': { date: true, endDate: { range: 1, unit: 'hours' } },
      'bitmax': { date: true, endDate: { range: 4, unit: 'hours' } },
      'bitfinex': { date: true, endDate: { range: 1, unit: 'days' } },
      'huobi': { date: true, endDate: { range: 4, unit: 'hours' } },
      'binance_dex': { date: true, endDate: { range: 1, unit: 'days' } },
    }
    const defaultDate = moment.utc().subtract(4, 'hours').toDate()
    return {
      loading: true,
      form: {
        account: undefined,
        date: parseFormInputValue(Date, defaultDate),
        endDate: parseFormInputValue(Date, defaultDate),
      },
      accountService: new MongoConnector(getDefaultConnectorSchema(null, 'accounts')),
      accounts: [],
      accountSearch: undefined,
      exchangeConfigs,
      currentExchangeConfig: undefined
    }
  },
  async beforeMount () {
    await this.init()
  },
  watch: {
    'form.account' (v) {
      const { account_id: id, exchange } = v
      let options = {}
      if (this.exchangeConfigs[exchange]) {
        options = this.exchangeConfigs[exchange]
      }
      this.currentExchangeConfig = merge({
        date: true
      }, options)
      if (this.currentExchangeConfig.endDate) {
        const endDateConfig = this.currentExchangeConfig.endDate
        this.form.endDate = parseFormInputValue(Date, moment.utc(this.form.date).add(endDateConfig.range, endDateConfig.unit).toDate())
      }
    }
  },
  computed: {
    valid () {
      return !this.loading && this.form.account && !isNaN(+new Date(this.form.date)) && !isNaN(+new Date(this.form.endDate))
    }
  },
  methods: {
    async init () {
      this.loading = true
      this.accounts = await this.getAccounts()
      this.loading = false
    },
    async getAccounts () {
      return this.accountService.find({
        sort: { account_id: 1, exchange: 1 },
        projection: { account_id: 1, exchange: 1 },
        limit: 1000
      })
    },
    async submit () {
      this.loading = true
      try {
        const { account, date, endDate } = this.form
        const result = await MongoService.api.historicalTradeExecutions({
          'method': 'start',
          'accounts': [account.account_id],
          'updateDatabase': true,
          'lastTrade': {
            'date': moment.utc(date).toDate(),
            ...(this.currentExchangeConfig.endDate ? { endDate: moment.utc(endDate).toDate() } : {})
          }
        })
        MessageDialog.showSuccessMessage(
          this.parseNotificationResult({
            notificationName: `${account.account_id}`,
            message: JSON.stringify(result && result[0], null, 2)
          })
        )
      } catch (error) {
        MessageDialog.showErrorMessage({ text: error.toString() })
      }
      this.loading = false
    },
    parseNotificationResult ({ notificationName, message }) {
      return {
        width: '80%',
        html: `
          <div class='v-card theme--dark green lighten-1'>
            <div class='v-card__title title'>${notificationName}</div>
            <div class='v-card__text white black--text grey lighten-5'><pre>${message}</pre></div>
          </div>`
      }
    }
  }
}
</script>